import React from "react";
import page_before1 from "../images/page_before1.png";
import page_before2 from "../images/page_before2.png";
import page_after1 from "../images/page_after1.png";
import page_after2 from "../images/page_after2.png";
import dark_page_before1 from "../images/dark_page_before1.png";
import dark_page_before2 from "../images/dark_page_before2.png";
import dark_page_after1 from "../images/dark_page_after1.png";
import dark_page_after2 from "../images/dark_page_after2.png";

export default function Pagenation(props) {
  let pageCount;
  if (props.totalItemsCount > 0) {
    pageCount = Math.ceil(props.totalItemsCount / props.itemsPerPage);
  } else {
    pageCount = 1;
  }

  const handlePageArrowClick = (isNext) => {
    let page = props.selectedPage;
    if (isNext === false) {
      page = props.selectedPage - 1;
      if (page < 1) {
        page = 1;
      }
    } else {
      page = props.selectedPage + 1;
      if (page > pageCount) {
        page = pageCount;
      }
    }

    props.handlePageArrowClick(page, isNext)
  }

  const darkBoardContainer = document.querySelector('.darkBoardContainer');

  return (
    <div class="pagination col-group">
      <div class="pageControll">
        <div class="controll-wrap">
          <div class="arrow-wrap">
            <button class="arrow_btn">
              <img src={darkBoardContainer ? dark_page_before1 : page_before1} alt="carrybox" />
            </button>
            <button class="arrow_btn" onClick={() => handlePageArrowClick(false)}>
              <img src={darkBoardContainer ? dark_page_before2 : page_before2} alt="carrybox" />
            </button>
          </div>
          <div class="num-wrap">
            <input type="text" class="num_txt num_now" min={1} max={pageCount} value={props.selectedPage} onChange={(e) => props.setPage(e.target.value)} />
            <span class="slash">/</span>
            <div class="num_txt">{pageCount}</div>
          </div>
          <div class="arrow-wrap">
            <button class="arrow_btn" onClick={() => handlePageArrowClick(true)}>
              <img src={darkBoardContainer ? dark_page_after1 : page_after1} alt="carrybox" />
            </button>
            <button class="arrow_btn">
              <img src={darkBoardContainer ? dark_page_after2 : page_after2} alt="carrybox" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
